import colors from "tailwindcss/colors"

export const colorList = [
  [
    colors.cyan[300],
    "bg-cyan-300",
    "text-cyan-300",
    "from-cyan-300",
    "to-cyan-300",
  ],
  [
    colors.green[300],
    "bg-green-300",
    "text-green-300",
    "from-green-300",
    "to-green-300",
  ],
  [
    colors.purple[300],
    "bg-purple-300",
    "text-purple-300",
    "from-purple-300",
    "to-purple-300",
  ],
  [
    colors.yellow[300],
    "bg-yellow-300",
    "text-yellow-300",
    "from-yellow-300",
    "to-yellow-300",
  ],
  [
    colors.indigo[300],
    "bg-indigo-300",
    "text-indigo-300",
    "from-indigo-300",
    "to-indigo-300",
  ],
  [colors.red[300], "bg-red-300", "text-red-300", "from-red-300", "to-red-300"],
  [
    colors.blue[300],
    "bg-blue-300",
    "text-blue-300",
    "from-blue-300",
    "to-blue-300",
  ],
  [
    colors.pink[300],
    "bg-pink-300",
    "text-pink-300",
    "from-pink-300",
    "to-pink-300",
  ],
  [colors.sky[300], "bg-sky-300", "text-sky-300", "from-sky-300", "to-sky-300"],
]

export const darkColorList = [
  [
    colors.cyan[600],
    "bg-cyan-600",
    "text-cyan-600",
    "from-cyan-600",
    "to-cyan-600",
    "hover:text-cyan-600",
    "hover:border-cyan-300",
    "border-cyan-300",
  ],
  [
    colors.green[600],
    "bg-green-600",
    "text-green-600",
    "from-green-600",
    "to-green-600",
    "hover:text-green-600",
    "hover:border-green-300",
    "border-green-300",
  ],
  [
    colors.purple[600],
    "bg-purple-600",
    "text-purple-600",
    "from-purple-600",
    "to-purple-600",
    "hover:text-purple-600",
    "hover:border-purple-300",
    "border-purple-300",
  ],
  [
    colors.yellow[600],
    "bg-yellow-600",
    "text-yellow-600",
    "from-yellow-600",
    "to-yellow-600",
    "hover:text-yellow-600",
    "hover:border-yellow-300",
    "border-yellow-300",
  ],
  [
    colors.indigo[600],
    "bg-indigo-600",
    "text-indigo-600",
    "from-indigo-600",
    "to-indigo-600",
    "hover:text-indigo-600",
    "hover:border-indigo-300",
    "border-indigo-300",
  ],
  [
    colors.red[600],
    "bg-red-600",
    "text-red-600",
    "from-red-600",
    "to-red-600",
    "hover:text-red-600",
    "hover:border-red-300",
    "border-red-300",
  ],
  [
    colors.blue[600],
    "bg-blue-600",
    "text-blue-600",
    "from-blue-600",
    "to-blue-600",
    "hover:text-blue-600",
    "hover:border-blue-300",
    "border-blue-300",
  ],
  [
    colors.pink[600],
    "bg-pink-600",
    "text-pink-600",
    "from-pink-600",
    "to-pink-600",
    "hover:text-pink-600",
    "hover:border-pink-300",
    "border-pink-300",
  ],
  [
    colors.sky[600],
    "bg-sky-600",
    "text-sky-600",
    "from-sky-600",
    "to-sky-600",
    "hover:text-sky-600",
    "hover:border-sky-300",
    "border-sky-300",
  ],
]

export default colorList
